import React from "react";
import { Link } from "react-router-dom";
import {
  FiTwitter,
  FiFacebook,
  FiLinkedin,
  FiYoutube,
  FiPhone,
} from "react-icons/fi";
import Logo from "./Logo";
import { SALES_PHONE } from "../config/brand";

const COLUMNS = [
  {
    title: "Product",
    links: [
      { to: "/features", label: "Features" },
      { to: "/pricing", label: "Pricing" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/about", label: "About" },
      { to: "/contact", label: "Contact" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/privacy", label: "Privacy Policy" },
      { to: "/terms", label: "Terms & Conditions" },
    ],
  },
];

const SOCIALS = [
  { icon: FiTwitter, label: "Twitter" },
  { icon: FiFacebook, label: "Facebook" },
  { icon: FiLinkedin, label: "LinkedIn" },
  { icon: FiYoutube, label: "YouTube" },
];

export default function Footer() {
  return (
    <footer className="bg-navy text-slate-300">
      <div className="section-container py-12">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-5">
          <div className="md:col-span-2">
            <Logo light />
            <p className="mt-4 max-w-xs text-sm text-slate-400">
              Smart accounting software that helps businesses manage finances,
              send invoices, and grow with confidence.
            </p>
            {/* A number someone can actually call, not a form to fill in. */}
            <p className="mt-5 text-sm">
              <span className="block text-xs font-semibold uppercase tracking-wider text-slate-500">
                Sales
              </span>
              <a
                href={`tel:${SALES_PHONE.replace(/[^0-9]/g, "")}`}
                className="mt-1 inline-flex items-center gap-2 text-base font-semibold text-white transition-colors hover:text-primary"
              >
                <FiPhone size={16} aria-hidden="true" />
                {SALES_PHONE}
              </a>
            </p>
            <div className="mt-5 flex items-center gap-3">
              {SOCIALS.map(({ icon: Icon, label }) => (
                <a
                  key={label}
                  href="/"
                  onClick={(e) => e.preventDefault()}
                  aria-label={label}
                  className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/5 text-slate-300 transition-colors hover:bg-primary hover:text-white"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold uppercase tracking-wider text-white">
                {col.title}
              </h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-slate-400 transition-colors hover:text-white"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 border-t border-white/10 pt-6 text-center text-sm text-slate-500">
          © {new Date().getFullYear()} Money Flow Accounting. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
